import { makeStyles } from "@material-ui/styles";

export const useLoginStyles: any = makeStyles(
  (theme: { [key: string]: any }) => ({
    mainContainer: {
      height: "100vh",
      overflow: "hidden",
    },

    credentialContainer: {
      padding: theme.spacing(4, 4),
    },
    labelStyle: {
      fontSize: "0.813rem",
      fontWeight: "lighter",
    },
    title: {
      fontWeight: 800,
    },
    titlePaper: {
      fontWeight: "bold",
    },
    fab: {
      color: "white",
      width: "12em",
      textTransform: "none",
      fontSize: "1.2em",
    },
    textFieldwidth: {
      width: "30em",
    },

    margin: {
      marginTop: theme.spacing(3),
    },
    paper: {
      borderRadius: "0.7em",
      alignItems: "center",
      justifyContent: "center",
    },
    credentials: {
      fontSize: "0.9em",
      fontWeight: "bold",
    },
    formControlLabelMarginTop: {
      marginTop: "2em",
    },
    checkboxMarginLeft: {
      marginLeft: "1.6em",
    },
    rememberTypography: {
      fontSize: "0.7rem",
      fontWeight: "bold",
    },
    forgotTypography: {
      fontSize: "0.7rem",
      marginTop: "3em",
      marginLeft: "2em",
      color: "#e91e63",
      fontWeight: "bold",
    },
    iconColor: { color: "#9e9e9e" },
    circle: {
      backgroundColor: "#f7941d",
    },
    message: {
      color: "#f44336",
      fontSize: "0.9em",
    },
    errorStyle: {
      color: "#b71c1c",
      fontSize: "0.875rem",
      paddingTop: "0.5em",
    },
    buttonProgress: {
      color: "#1b5e20",
      position: "absolute",
      left: "50%",
      marginTop: "1em",
    },
  })
);
